import { html, Page, View } from 'rune-ts';
import { LayoutView } from '@services/MarppleShop/renderApp/components/cells/Layout/LayoutView.ts';
import { footer_links } from '@services/MarppleShop/renderApp/components/cells/Footer/constant.ts';
import { CurationDetail, CurationListItem } from '@services/MarppleShop/features/Curation/type';
import { ProductCardViewData } from '@services/MarppleShop/features/ProductList/type';
import { BaseLayoutOptions } from '@services/MarppleShop/features/Core/service';
import klass from './LatestCurationFeed.module.scss';
import { CateRootGnbMoView } from '@services/MarppleShop/renderApp/components/cells/CateRootGnbMo/CateRootGnbMoView.ts';
import { CategoryLevel1_CODE } from '../../../../../../shared/mps-shared/domain/category/types.ts';
import { TabView } from '@services/MarppleShop/shared/components/atoms/Tabs/TabView.ts';
import { CurationThumbnailView } from '@services/MarppleShop/renderApp/pages/Curation/components/CurationThumbnailView.ts';
import { main_detail } from '@modules/MShop/App/Today/S/Tmpl/main_detail';
import { CardProductView } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';
import { updateLikeMarppleShop } from '@modules/MShop/App/Product/Item/F/Function/updateLikeMarppleShop';
import { Confirm } from '@services/MarppleShop/renderApp/components/cells/Confirm/Confirm.ts';
import { preventEscape } from '@services/MarppleShop/shared/util/preventEscape.ts';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF';
import { pushLoginStack } from '@modules/Creator/Login/F/fs';
import { fx, noop, pipe } from '@fxts/core';
import { CardCurationView } from '@services/MarppleShop/renderApp/pages/Curation/components/CardCurationView.ts';
import { ButtonView } from '@services/MarppleShop/shared/components/atoms/Buttons/ButtonView.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { classes } from '@services/MarppleShop/shared/util';
import { makeEmptyScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { DetachedTabView } from '@services/MarppleShop/renderApp/pages/Curation/LatestCurationFeed/DetachedTabView.ts';
import { hydrateFeed } from '@services/MarppleShop/renderApp/pages/CurationDetail/util.ts';

const CURATION_TAB_LIMIT = 5;

const LATEST_CURATION_LIMIT = 4;

type TProps = {
  recent_product: ProductCardViewData | undefined;
  layout_options: BaseLayoutOptions;
  curations: CurationListItem[];
  curation_detail: CurationDetail;
  query: {
    cid?: string;
  };
};

class BodyView extends View<TProps> {
  /**
   * @see https://github.com/marpple/marpple-web/blob/c69213b737c26d28b5417bc5767aaf4a2b953760/services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardView.ts#L301-L329
   */
  private async handleCardProductLikeClick(product_id: number) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const target_curation_product = this.data.curation_detail.products.find(
      (product) => product.id === product_id,
    )!;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!target_curation_product.user_id || window.box.sel('is_user->type') == 'TEMP') {
      const confirmed = (await Confirm.open({
        title: ET('mps2::login::need_login::title'),
        message: preventEscape(ET('mps2::login::need_login::message')),
        confirmText: ET('mps2::login::login'),
        cancelText: ET('mps2::signup::close'),
      })) as boolean;

      if (confirmed) {
        if (MShopUtilF.isApp()) {
          pushLoginStack();
        } else {
          location.href = `/${T.lang}/@/login?url=${location.pathname + location.search}`;
        }
      }
    } else {
      try {
        const next_is_liked = !target_curation_product.is_liked;
        updateLikeMarppleShop(!next_is_liked, target_curation_product.stores_product_id);

        this.data.curation_detail.products = this.data.curation_detail.products.map((product) =>
          product.id === product_id ? { ...product, is_liked: next_is_liked } : product,
        );
        this.subViews(CardProductView)
          .filter((card_product_view) => card_product_view.data.product_image.id === product_id)
          .forEach((card_product_view) => card_product_view.setProductImageIsLiked(next_is_liked));
      } catch {
        noop();
      }
    }
  }

  protected override onMount() {
    this.element().querySelector(`.${klass.tab_item}[data-is-selected="true"]`)?.scrollIntoView({
      behavior: 'instant',
      block: 'nearest',
      inline: 'start',
    });
  }

  protected override template({ curations, curation_detail, query }: TProps) {
    return html`<div class="${klass.body}">
      ${new CateRootGnbMoView({ cate_root_code: CategoryLevel1_CODE.CURATION })}

      <nav class="${klass.curation_tab}">
        <ul class="${klass.tab_list}">
          ${fx(curations)
            .take(CURATION_TAB_LIMIT)
            .toArray()
            .map((curation, i) => {
              const isSelected = query.cid ? curation.id === Number(query.cid) : i === 0;

              return html`<li class="${klass.tab_item}" data-is-selected="${isSelected}">
                <a href="${`/${ET.lang}/@/latest-curation-feed?cid=${curation.id}`}">
                  ${new TabView({
                    size: 'S',
                    thumbnail: 'Off',
                    state: isSelected ? 'On' : 'Off',
                    text: html.preventEscape(curation.tags[0] ?? curation.title),
                  })}
                </a>
              </li>`;
            })}

          <li class="${klass.tab_item}">
            <a
              href="${`/${ET.lang}/@/curation-feed`}"
              data-post-message="${pipe(`/${ET.lang}/@/curation-feed`, makeEmptyScreenNavigate, dataStr)}"
            >
              ${new DetachedTabView({
                size: 'S',
                thumbnail: 'Off',
                state: 'On',
                text: ET('curation::latest_curation_feed_page::detached_tab_text'),
              })}
            </a>
          </li>
        </ul>
      </nav>

      ${new CurationThumbnailView({
        ...curation_detail,
        device: 'Mobile',
        theme: curation_detail.theme === 'Light' ? 'Dark' : 'Light',
      })}
      ${html.preventEscape(
        main_detail({
          is_mobile: true,
          today: curation_detail,

          steps: null,
          is_sharable: null,
          next_today: null,
          prev_today: null,
          feed_category_id: null,
          products_html: null,
          related_section_title: null,
          related_todays_html: null,
          show_related_see_more: null,
        }),
      )}

      <div class="${klass.curation_products}">
        <span class="${font('18_semibold')}">
          ${ET('curation::latest_curation_feed_page::curation_products_text')}
        </span>

        <div class="${klass.product_list}">
          ${curation_detail.products.map(
            (product) =>
              new CardProductView({
                type: 'G',
                size: 'Xsmall',
                layout: 'Vertical',
                theme: 'Light',
                state: CardProductView.getState(product),
                product_image: {
                  domain_name: product.domain_name,
                  thumbnail_info: product.thumbnail_info,
                  resize_width: 126 * 2,
                  is_lazy: true,
                  is_liked: product.is_liked,
                  name: product.name,
                  id: product.id,
                  store_name: product.store_name,
                },
                product_title: {
                  id: product.id,
                  domain_name: product.domain_name,
                  name: product.name,
                },
                price: {
                  price: product.price,
                  price_en: product.price_en,
                  price_jp: product.price_jp,
                },
                review: {
                  review_count: product.review_count,
                  review_score: product.review_score,
                },
                count_view: {
                  watcher_count: product.watcher_count ?? 0,
                },
                onProductImageLikeClick: () => this.handleCardProductLikeClick(product.id),
              }),
          )}
        </div>
      </div>

      <div class="${klass.curation_latest}">
        <span class="${classes(klass.section_title, font('18_semibold'))}">
          ${ET('curation::latest_curation_feed_page::section_title')}
        </span>

        <div class="${klass.list}">
          ${fx(curations)
            .reject((curation) => curation.id === curation_detail.id)
            .take(LATEST_CURATION_LIMIT)
            .map(
              (curation) =>
                html`<article class="${klass.item}">
                  ${new CardCurationView({
                    device: 'Mobile',
                    layout: 'Thumbnail',
                    ...curation,
                  })}
                </article>`,
            )
            .toArray()}
        </div>

        <div class="${klass.button_container}">
          ${new ButtonView({
            size: 40,
            color: 'Custom-A',
            label: ET('curation::latest_curation_feed_page::button_text'),
            as: 'a',
            href: `/${ET.lang}/@/curation-feed`,
            dataset: {
              postMessage: pipe(`/${ET.lang}/@/curation-feed`, makeEmptyScreenNavigate, dataStr),
            },
          })}
        </div>
      </div>
    </div>`;
  }
}

export class LatestCurationFeedPage extends Page<TProps> {
  protected override onMount() {
    hydrateFeed(this.element());
  }

  protected override template(props: TProps) {
    const { layout_options, curation_detail } = props;

    return html`<div>
      ${new LayoutView(
        {
          body: new BodyView(props),
          footer_data: { ...footer_links, lang: ET.lang, is_mobile: layout_options.is_mobile },
        },
        {
          full_width: layout_options.is_mobile,
          floating_box: {
            share: layout_options.is_mobile
              ? {
                  title: curation_detail.title,
                  description: curation_detail.description,
                }
              : undefined,
            up: true,
          },
          ...layout_options,
          selected_bottom_tab_idx: 0,
          has_bottom_tab_bar: true,
        },
      )}
    </div>`;
  }
}
